<template>
  <layout-basic>
    <v-container fluid style="padding-bottom: 0; padding-top: 10px">
      <v-row>
        <v-col md="12">
          <v-btn color="secondary" outlined class="mr-1" to="/admin/reports">
            <v-icon class="mr-1" small>fa-chevron-left</v-icon> Back to Reports
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card flat class="v-card-bg-none">
            <v-card-actions>
              <v-text-field
                class="search-box"
                placeholder="Search Groups"
                prepend-icon="fa-search"
                v-model="search"
                type="text"
                clearable
                clear-icon="fa-times"
                @click:clear="resetSearch"
                @change="applySearch"
              ></v-text-field>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              v-show="!loading"
              :items="groups"
              :footer-props="{
                'items-per-page-options': [5, 10, 15],
              }"
            >
            <template v-slot:item.total_users="{ item }">
                    <span v-if="item.total_users" class="clickable-count" @click.stop="openDialog($event,item.users,'Users')">{{ item.total_users }}</span>
                    <span v-else>{{ item.total_users }}</span>
              </template>
            <template v-slot:item.total_courses="{ item }">
                    <span v-if="item.total_courses" class="clickable-count" @click.stop="openDialog($event,item.courses,'Courses')">{{ item.total_courses }}</span>
                    <span v-else>{{ item.total_courses }}</span>
              </template>
              <template v-slot:item.total_channels="{ item }">
                    <span v-if="item.total_channels" class="clickable-count" @click.stop="openDialog($event,item.channels,'Playlists')">{{ item.total_channels }}</span>
                    <span v-else>{{ item.total_channels }}</span>
              </template>
              
              <template v-slot:item.id="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      small
                      text
                      color="secondary"
                      @click="downloadReport(item.id)"
                    >
                      <img :src=" '/static/download-report-icon.png'" alt="Download">
                    </v-btn>
                  </template>
                  <span>Download</span>
                </v-tooltip>
              </template>
          </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <!-- Dialog -->
      <DialogComponent
        :isOpen="dialog"
        :dialogTitle="dialogTitle"
        :dialogData="dialogData"
        @close="closeDialog"
        />
    </v-container>
  </layout-basic>
</template>
<script>
import GroupAPI from '@/api/group.js';
import LayoutBasic from '@/layouts/Dashboard';
import DialogComponent from '@/components/Dialog';

export default {
  name: 'GroupReport',
  components: {
    LayoutBasic,
    DialogComponent
  },
  data() {
    return {
      headers: [
        { text: 'Name', value: 'name', align: 'left' },
        { text: 'Users', value: 'total_users', sortable: false },
        { text: 'Courses', value: 'total_courses', sortable: false },
        { text: 'Playlists', value: 'total_channels', sortable: false },
        { text: 'Download Report', value: 'id', sortable: false, align: 'end' },
      ],
      groups: [],
      pagination: {},
      options: {},
      loading: false,
      search: '',
      searchParams: '',
      dialog: false,
      dialogTitle : '',
      dialogData: [],
      successExportMessage:
        'Your request to report will be processed and you will receive an email shortly with the link to the report.',
    };
  },
  computed: {
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options) + this.searchParams;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getGroups();
      },
      deep: true,
    },
  },
  methods: {
    resetSearch() {
      this.options.page = 1;
      this.searchParams = '';
      this.getGroups();
    },
    applySearch() {
      this.options.page = 1;
      this.searchParams =
        this.search != null
          ? this.params + '&search=name:' + this.search
          : this.params;
      this.getGroups();
    },
    getGroups() {
      this.loading = true;
      GroupAPI.getGroups(this.params, '').then((resp) => {
        this.loading = false;
        this.groups = resp.data.data;
        this.pagination = resp.data.meta.pagination;
      });
    },
    applyGroupSearch() {
      this.groupSearchParams =
        this.groupParams + '&search=name:' + this.groupSearch;
      this.getGroups();
    },
    openDialog(event, data, title) {
      this.dialogTitle = title;
      this.dialogData = data;
      this.dialog = true;
      document.getElementById('improve').style.pointerEvents = 'none';
      document.getElementById('navbar-collapse').style.pointerEvents = 'none';
    },
    closeDialog() {
      document.getElementById('improve').style.pointerEvents = 'unset';
      document.getElementById('navbar-collapse').style.pointerEvents = 'unset';
      this.dialog = false;
    },
    downloadReport(groupId){
      this.loading = true;
      GroupAPI
        .exportGroupReport(groupId)
        .then(() => {
          this.$snotify.success(this.successExportMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    }
  },
};
</script>
